import { kitHistoryOperationsTypes } from "@utils/kit_history_types";
import { Modal } from "flowbite-react";
import { HiCalendar, HiMail, HiRefresh, HiUser } from "react-icons/hi";
import { useSelector } from "react-redux";
import { customModalTheme } from "styles/customTheme";

export const ModalKitHistoryDetails = ({ index, isOpenDetails, activity, closeModal }) => {
	const { token, permissions, role } = useSelector((state) => state.auth.user);

	const operationType =
		kitHistoryOperationsTypes.find((item) => item.value === activity?.type)?.label || "-";

	return (
		<Modal show={isOpenDetails} onClose={closeModal} id={index} size="5xl" theme={customModalTheme}>
			<Modal.Header>
				<div className="flex items-center">
					<div>
						<h2 className="text-blue-gray text-xl capitalize">{operationType.replace("_", " ")}</h2>
					</div>
				</div>
			</Modal.Header>

			<Modal.Body className="space-y-4 bg-navbar-bg p-4">
				{/* Overview Card */}
				<div className="overflow-hidden rounded-3xl border border-[#1F2547] bg-gradient-to-br from-[#1A1F3A] to-[#242846] shadow-2xl">
					{/* Header */}
					<div className="border-[#2A315D] border-b bg-[#343959]/80 px-6 py-4 backdrop-blur">
						<h5 className="font-semibold text-sm text-white uppercase tracking-[1px]">
							Overview Details
						</h5>
					</div>

					{/* Content */}
					<div className="space-y-4 p-4">
						{/* Done By */}
						<div className="flex items-center justify-between gap-1 border-[#2E335A] border-b pb-2">
							<div className="flex items-center gap-2">
								<div className="rounded-lg bg-[#2D3561] p-2">
									<HiUser className="h-4 w-4 text-blue-300" />
								</div>

								<span className="text-gray-300 text-xs sm:text-sm">Done By</span>
							</div>

							<span className="rounded-lg bg-[#2B3055] px-3 py-1 font-medium text-white text-xs sm:text-sm">
								{activity?.done_by || "-"}
							</span>
						</div>

						{/* Created Date */}
						<div className="flex items-center justify-between border-[#2E335A] border-b pb-2">
							<div className="flex items-center gap-2">
								<div className="rounded-lg bg-[#2D3561] p-2">
									<HiCalendar className="h-4 w-4 text-cyan-300" />
								</div>

								<span className="text-gray-300 text-xs sm:text-sm">Date</span>
							</div>

							<span className="rounded-lg bg-[#2B3055] px-3 py-1 font-medium text-white text-xs sm:text-sm">
								{activity?.created_at
									? activity.created_at.replace("T", " ").replace(".000000Z", "")
									: "-"}
							</span>
						</div>

						{/* Change Plan */}
						{activity?.change_plan_details && (
							<div className="border-[#2E335A] border-b pb-2">
								<div className="mb-4 flex items-center gap-3">
									<div className="rounded-lg bg-[#2D3561] p-2">
										<HiRefresh className="h-4 w-4 text-green-300" />
									</div>

									<span className="text-gray-300 text-xs sm:text-sm">Change Plan Details</span>
								</div>

								<div className="grid grid-cols-1 gap-4 md:grid-cols-3">
									<div className="rounded-2xl border border-[#2F3763] bg-[#1D2342] p-4">
										<p className="mb-2 text-gray-400 text-xs uppercase tracking-wide sm:text-sm">
											Type
										</p>

										<p className="font-semibold text-white text-xs sm:text-base">
											{activity.change_plan_details.type || "-"}
										</p>
									</div>

									<div className="rounded-2xl border border-[#2F3763] bg-[#1D2342] p-4">
										<p className="mb-2 text-gray-400 text-xs uppercase tracking-wide sm:text-sm">
											Old Plan
										</p>

										<p className="font-semibold text-orange-300 text-xs sm:text-base">
											{activity.change_plan_details.old_plan || "-"}
										</p>
									</div>

									<div className="rounded-2xl border border-[#2F3763] bg-[#1D2342] p-4">
										<p className="mb-2 text-gray-400 text-xs uppercase tracking-wide sm:text-sm">
											New Plan
										</p>

										<p className="font-semibold text-green-300 text-xs sm:text-base">
											{activity.change_plan_details.plan || "-"}
										</p>
									</div>
								</div>
							</div>
						)}

						{/* Subject */}
						<div className="flex items-start justify-between gap-2">
							<div className="flex items-center gap-2">
								<div className="rounded-lg bg-[#2D3561] p-2">
									<HiMail className="h-4 w-4 text-pink-300" />
								</div>

								<span className="text-gray-300 text-xs sm:text-sm">Subject</span>
							</div>

							<div className="max-w-[70%] rounded-2xl border border-[#313862] bg-[#1C2140] p-2 text-right text-gray-100 text-xs leading-7 sm:text-sm">
								{activity?.json_data?.subject || "No subject"}
							</div>
						</div>
					</div>
				</div>

				{/* Emails Card */}
				<div className="overflow-hidden rounded-2xl border border-[#1F2547] bg-gradient-to-br from-[#1A1F3A] to-[#242846] shadow-2xl">
					<div className="border-[#2A315D] border-b bg-[#343959]/80 px-4 py-4 sm:px-6">
						<h5 className="font-semibold text-sm text-white uppercase tracking-[1px]">
							List of Emails Sent
						</h5>
					</div>

					<div className="custom-scrollbar max-h-64 overflow-y-auto p-4">
						{activity?.json_data?.users_notified?.length > 0 ? (
							<div className="grid gap-2">
								{activity?.json_data?.users_notified.map((email, index) => (
									<div
										key={index}
										className="group flex items-center gap-3 rounded-2xl border border-[#2f3455] bg-dark-blue bg-opacity-60 px-2 py-2 transition-all duration-300 hover:border-blue-gray hover:bg-[#27305B]"
									>
										<div className="rounded-xl bg-[#313862] p-2 transition-all duration-300 group-hover:bg-blue-gray">
											<HiMail className="h-3 w-3 text-white" />
										</div>

										<p className="break-all font-medium text-gray-100 text-xs leading-6 sm:text-sm">
											{email}
										</p>
									</div>
								))}
							</div>
						) : (
							<div className="flex h-40 items-center justify-center">
								<div className="text-center">
									<div className="mb-3 inline-flex rounded-2xl bg-[#2D3561] p-4">
										<HiMail className="h-6 w-6 text-gray-400" />
									</div>

									<p className="font-medium text-gray-400 text-sm">No email found</p>
								</div>
							</div>
						)}
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};
